import { ISlider } from "../models/ISlider";
import { configWithUserToken, configWithUserFileToken } from "./config";

export const getSliders = () =>
  configWithUserToken.get<ISlider[]>("Slider");

export const postSlider = (data: { image: File; title: string; description: string; displayOrder: number; linkUrl: string }) => {
  const formData = new FormData();
  formData.append("image", data.image);
  formData.append("title", data.title);
  formData.append("description", data.description);
  formData.append("displayOrder", String(data.displayOrder));
  if (data.linkUrl) formData.append("linkUrl", data.linkUrl);
  return configWithUserFileToken.post("Slider", formData);
};

export const putSlider = (id: string, data: { title: string; description: string; displayOrder: number; isEnabled: boolean; linkUrl: string }) => {
  const formData = new FormData();
  formData.append("title", data.title);
  formData.append("description", data.description);
  formData.append("displayOrder", String(data.displayOrder));
  formData.append("isEnabled", String(data.isEnabled));
  if (data.linkUrl) formData.append("linkUrl", data.linkUrl);
  return configWithUserFileToken.put(`Slider/${id}`, formData);
};

export const deleteSlider = (id: string) =>
  configWithUserToken.delete(`Slider/${id}`);
